import type { Program } from 'src/legacy/models/firebase'

export const ORIENTATION_LABEL = 'Orientation'
export const POST_PROGRAM_LABEL = 'Post-Program'

export const getThemeLabel = (weekNbr: number | null, lastWeekNbr: number, programThemes: Program['weeks']): string => {
  const week = weekNbr ?? 0
  if (week > lastWeekNbr) return POST_PROGRAM_LABEL
  if (week === 0) return ORIENTATION_LABEL
  return programThemes[`W${week}`]?.title ?? `Week ${week}`
}
